import React, { useState } from "react";

import { ColorPicker } from "@common/colorPicker";
import { VisibilityWatcher } from "@common/visibilityWatcher";
import { ZoneAvatar } from "../../zoneAvatar";
import { Props } from "./types";
import styles from "./styles.scss";
import { PenIcon } from "@common/penIcon";
import { PenIconHover } from "@common/penIconHover";
import classnames from "classnames";

function ColorForm(props: Props) {
  return (
    <VisibilityWatcher>
      {(isVisible, show, hide) => (
        <div className={styles.colorForm}>
          <div className={styles.avatar} onClick={isVisible ? hide : show}>
            <div className={styles.avatarWrapper}>
              <ZoneAvatar
                name={props.zone.name || "Z"}
                color={props.selectedColor}
              />
              <div className={styles.penIcon}>
                <PenIcon className={styles.icon} />
              </div>
            </div>

            <div
              className={styles.avatarHover}
              onClick={isVisible ? hide : show}
            >
              <PenIconHover className={styles.penIconHover} />
            </div>
          </div>

          {isVisible && (
            <div className={styles.colorPicker}>
              <ColorPicker
                color={props.selectedColor || "\\#ef6167"}
                pick={props.selectColor}
              />
            </div>
          )}
        </div>
      )}
    </VisibilityWatcher>
  );
}

export { ColorForm };
